import { render, staticRenderFns } from "./OrderDropdown.vue?vue&type=template&id=393ee43a"
import script from "./OrderDropdown.vue?vue&type=script&lang=js"
export * from "./OrderDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports